import { ListItemIcon as MUIListItemIcon } from '@mui/material';
import { withStyles } from 'tss-react/mui';

export const ListItemIcon = withStyles(MUIListItemIcon, {
  root: { minWidth: '2rem' }
});

export default ListItemIcon;
